<template>
  <main
    role="main"
    class="col content-spacing"
    style="max-width: 88% !important;"
  >
    <PageHeader pageTitle="Comissões" class="page-header-comission">
      <div style="display: flex; gap: 0.5rem;">
        <SelectYear v-model="search.year" />
        <SelectMonth v-model="search.month" />
        <SelectPromoter
          v-if="oldCommissionList.length"
          :traderList="traderList"
          v-model="search.trader"
        />
        <SelectProfile
          v-if="oldCommissionList.length"
          v-model="search.profile"
        />
        <SelectInvoiceNumberStatus
          v-if="oldCommissionList.length"
          :invoiceNumberList="invoiceNumberList"
          v-model="search.invoiceNumber"
        />
        <SelectCommissionStatus
          v-if="oldCommissionList.length"
          v-model="search.status"
        />
        <BaseButtonComponent
          @click="getAll()"
          variant="primary-action"
          v-if="search.year && search.month"
        >
          Buscar
        </BaseButtonComponent>
        <VueJsonToCsv block :json-data="CSVCommissionList" :separator="';'">
          <BaseButtonComponent
            block
            variant="primary-action"
            :disabled="!CSVCommissionList.length"
          >
            CSV
          </BaseButtonComponent>
        </VueJsonToCsv>
      </div>
      <div
        style="display: flex; justify-content: space-between; align-items: center;"
      >
        <CommissionCounter
          :commissionList="commissionList"
          :key="commissionList.length"
        />
        <div style="display: flex; gap: 0.5rem; height: 100%;">
          <BaseButtonComponent
            @click="closeCommissionPeriod()"
            :disabled="!openCommissionList.length"
            variant="primary-action"
          >
            Fechar Período
          </BaseButtonComponent>
          <BaseButtonComponent
            @click="handleMarkCommissionsItemAsPaidInBatch()"
            :disabled="!commissionList.length"
            variant="primary-action"
          >
            Pagou Lote
          </BaseButtonComponent>
          <BaseButtonComponent
            @click="showDeleteCommissionInBatchDialog()"
            :disabled="!commissionList.length"
            variant="primary-action"
          >
            Deletar Lote
          </BaseButtonComponent>
        </div>
      </div>
    </PageHeader>
    <loading-list v-if="isLoading" />
    <div
      class="d-flex justify-content-between flex-column"
      v-if="!isLoading && commissionList.length !== 0"
    >
      <Table style="margin-top: 1rem;" class="commission-table">
        <TableHeader>
          <TableRow>
            <TableHead
              v-for="(commissionCol, index) of commissionColumns"
              :key="`${commissionCol}_${index}`"
            >
              <ColumnHeader
                :sort="commissionCol.sort"
                :somatory="commissionCol.somatory"
                :columnName="commissionCol.name"
                :columnKey="commissionCol.key"
                :columnType="commissionCol.columnType"
                :currentColumnFiltered="currentColumnFiltered"
                :sortDirection="sortDirection"
                :dataList="commissionList"
                v-on:sortListByKey="sortListByKey(commissionCol.key)"
              />
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow
            v-for="(commision, index) of commissionList"
            :key="`${commision}_${index}`"
          >
            <TableCell>
              {{ commision.nameCoupon }}
            </TableCell>
            <TableCell>
              <RenderProfileColumnValue :profile="commision.profile" />
            </TableCell>
            <TableCell>
              {{ commision.installationNumber }}
            </TableCell>
            <TableCell>
              <RenderNameColumnValue :name="commision.nameTrader" />
            </TableCell>
            <TableCell>
              <RenderNameColumnValue :name="commision.investorCustomerName" />
            </TableCell>
            <TableCell>
              <RenderMoneyColumnValue :value="commision.value" />
            </TableCell>
            <TableCell>
              {{ commision.comission }}
            </TableCell>
            <TableCell>
              <RenderMoneyColumnValue :value="commision.comissionCalc" />
            </TableCell>
            <TableCell>
              <RenderCommissionStatusColumnValue :value="commision.status" />
            </TableCell>
            <TableCell>
              {{ commision.invoice }}
            </TableCell>
            <TableCell>
              {{ commision.xmlInvoice }}
            </TableCell>
            <TableCell>
              <RenderDateColumnValue :value="commision.inputDate" />
            </TableCell>
            <TableCell>
              <RenderDateColumnValue :value="commision.paidDate" />
            </TableCell>
            <TableCell class="options-button">
              <BaseButtonComponent
                variant="confirmation-action"
                :disabled="commision.status !== 'INVOICE_CREATED'"
                @click="handleChangeCommissionToPaid(commision)"
              >
                Pagou
              </BaseButtonComponent>
              <BaseButtonComponent
                variant="danger"
                :disabled="!commision.id"
                @click="showDeleteCommissionDialog(commision.id)"
              >
                Deletar
              </BaseButtonComponent>
            </TableCell>
            <TableCell>
              {{ commision.contract }}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
    <empty-list v-if="!isLoading && commissionList.length === 0" />
    <b-modal
      id="delete-modal"
      ref="deleteModalRef"
      size="sm"
      title="Aviso"
      centered
      @ok="handleDeleteCommission"
    >
      <p class="my-4">Deseja realmente excluir essa comissão?</p>
    </b-modal>
    <b-modal
      id="delete-modal-in-batch"
      ref="deleteModalInBatchRef"
      size="sm"
      title="Aviso"
      centered
      @ok="handleDeleteCommissionItemInBatch"
    >
      <p class="my-4">Deseja realmente excluir todas essas comissões?</p>
    </b-modal>
  </main>
</template>

<script>
import { PageHeader } from '../../ui/page-header';
import {
  SelectMonth,
  SelectPromoter,
  SelectProfile,
  SelectYear,
} from '../../ui/selects';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../ui/table';
import {
  CommissionCounter,
  RenderCommissionStatusColumnValue,
  SelectCommissionStatus,
  SelectInvoiceNumberStatus,
} from '../../modules/comission/components';
import {
  RenderMoneyColumnValue,
  RenderNameColumnValue,
  RenderProfileColumnValue,
  RenderSortColumn,
  RenderDateColumnValue,
} from '../../ui/render';
import {
  defineArrowDirection,
  sortByProperty,
  formatCurrencyFraction2,
  filterListByProperty,
} from '../../utils';
import { COMMISSION_STATUS } from '../../modules/comission/constants';
import { Api } from '../../vue/api';
import VueJsonToCsv from 'vue-json-to-csv';
import { ColumnHeader } from '../../ui/column-header';
import { BaseButtonComponent } from '../../ui/buttons';
const API = new Api();

/**
 * Objeto que representa as comissões para a construção da tabela
 * @typedef {Object} Commission
 * @property {number} id
 * @property {string} nameCoupon
 * @property {"consumer" | "trader" | "investor"} profile
 * @property {number} installationNumber
 * @property {string} nameTrader
 * @property {string} investorCustomerName
 * @property {number} comission
 * @property {number} value Valor Recebido
 * @property {number} comissionCalc Calculo da Comissão
 * @property {"TO_BE_PAID" | "INVOICE_CREATED" | "PAID"} status
 * @property {string} invoice
 * @property {string} xmlInvoice
 * @property {string} inputDate
 * @property {string} paidDate
 * @property {string} contract
 */

/**
 * Objeto de comissões mapeados para o formato CSV
 * @typedef {Object} CSVCommission
 * @property {string} Cupom
 * @property {"consumer" | "trader" | "investor"} Perfil
 * @property {number} Instalacao
 * @property {string} Promotor
 * @property {string} investorCustomerName
 * @property {number} Comissao
 * @property {number} Valor_de_Incidencia Valor Recebido
 * @property {number} Comissão_Calculada Calculo da Comissão
 * @property {"Á pagar" | "Faturado" | "Pago"} Status
 * @property {string} Fatura
 * @property {string} Fatura_XML
 * @property {string} Data_de_Entrada
 * @property {string} Data_de_Pagamento
 * @property {string} Contrato
 */

export default {
  components: {
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHead,
    SelectYear,
    PageHeader,
    TableHeader,
    SelectMonth,
    VueJsonToCsv,
    ColumnHeader,
    SelectProfile,
    SelectPromoter,
    RenderSortColumn,
    CommissionCounter,
    RenderDateColumnValue,
    RenderNameColumnValue,
    RenderMoneyColumnValue,
    RenderProfileColumnValue,
    BaseButtonComponent,
    RenderCommissionStatusColumnValue,
    SelectCommissionStatus,
    SelectInvoiceNumberStatus,
  },
  data() {
    return {
      search: {
        month: null,
        trader: null,
        year: null,
        profile: null,
        status: null,
        invoiceNumber: null,
      },
      currentColumnFiltered: '',
      sortDirection: 'ASC',
      isLoading: false,
      openCommissionList: [],
      /**
       * Lista de comissões
       * @type {Commission[]}
       */
      commissionList: [],
      /**
       * Lista de comissões com dados preservados da consulta a API
       * @type {Commission[]}
       */
      oldCommissionList: [],
      /**
       * Lista de comissões formato CSV
       * @type {CSVCommission[]}
       */
      CSVCommissionList: [],
      commissionColumns: [
        {
          name: 'Cupom',
          key: 'nameCoupon',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Perfil',
          key: 'profile',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Instalação',
          key: 'installationNumber',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Promotor',
          key: 'nameTrader',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Cliente',
          key: 'investorCustomerName',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Receita Veins',
          key: 'value',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Comissão',
          key: 'comission',
          columnType: '(%)',
          sort: true,
          somatory: false,
        },
        {
          name: 'Comissão',
          key: 'comissionCalc',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Status',
          key: 'status',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Fatura',
          key: 'invoice',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Fatura XML',
          key: 'xmlInvoice',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Data Input',
          key: 'inputDate',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Data Pago',
          key: 'paidDate',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Opção',
          key: '',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Referência',
          key: 'contract',
          columnType: '',
          sort: false,
          somatory: false,
        },
      ],
      idDeleteCommission: null,
      traderList: [],
      invoiceNumberList: [],
    };
  },
  computed: {
    profile() {
      return this.search.profile;
    },
    trader() {
      return this.search.trader;
    },
    year() {
      return this.search.year;
    },
    month() {
      return this.search.month;
    },
    status() {
      return this.search.status;
    },
    invoiceNumber() {
      return this.search.invoiceNumber;
    },
  },
  watch: {
    profile() {
      this.handleFilterCommissionList();
    },
    trader() {
      this.handleFilterCommissionList();
    },
    year() {
      this.getAll();
    },
    month() {
      this.getAll();
    },
    status() {
      this.handleFilterCommissionList();
    },
    invoiceNumber() {
      this.handleFilterCommissionList();
    },
  },
  methods: {
    /**
     * @return {function(): void}
     */
    async getAll() {
      if (!this.search.year || !this.search.month) return;

      this.isLoading = true;

      const { model, ok } = await API.post('/execute', {
        path:
          '/commission-item/list' + `/${this.search.month}/${this.search.year}`,
        method: 'get',
      });

      if (ok) {
        const commissionData = model.list.map(commission => ({
          id: commission.id || '',
          nameCoupon: commission.nameCoupon || '',
          profile: commission.profile || '',
          installationNumber: commission.installationNumber || '',
          nameTrader: commission.nameTrader || '',
          investorCustomerName: commission.investorCustomerName || '',
          comission: commission.comission || '',
          value: commission.value || '',
          comissionCalc: commission.comissionCalc || '',
          status: commission.status || '',
          invoice: commission.invoice || '',
          xmlInvoice: commission.xmlInvoice || '',
          inputDate: commission.inputDate || '',
          paidDate: commission.paidDate || '',
          contract: commission.contract || '',
        }));
        this.commissionList = commissionData;
        this.oldCommissionList = commissionData;
        this.traderList = commissionData.map(
          commission => commission.nameTrader,
        );
        this.invoiceNumberList = commissionData.map(commission => {
          if (
            commission.invoice !== null &&
            commission.invoice !== undefined &&
            commission.invoice !== ''
          )
            return commission.invoice;
          return;
        });
        this.openCommissionList = model.listOpenComissions;
        this.CSVCommissionList = this.parseCommissionListToCSVCommissionList(
          commissionData,
        );
        this.handleFilterCommissionList();
      }
      this.isLoading = false;
    },
    /**
     * @param {string} columnKey
     * @return {function(): void}
     */
    sortListByKey(columnKey) {
      this.sortDirection = defineArrowDirection(
        this.currentColumnFiltered,
        columnKey,
        this.sortDirection,
      );
      this.currentColumnFiltered = columnKey;
      sortByProperty(this.commissionList, columnKey, this.sortDirection);
    },
    /**
     * Método para fechamento das comissões
     * @return {function(): void}
     */
    async closeCommissionPeriod() {
      this.isLoading = true;
      const { ok, errors } = await API.post('/execute', {
        path:
          '/commission-item/mark-as-closed' +
          `/${this.search.month}/${this.search.year}`,
        method: 'post',
        data: this.openCommissionList,
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
      } else {
        this.$bvToast.toast('Período fechado com sucesso', {
          title: `Sucesso`,
          variant: 'success',
          solid: true,
        });
      }
      await this.getAll();
      this.isLoading = false;
    },
    /**
     * Método para mapear os dados de comissão para formato CSV
     * @param {Commission[]} commissionList
     * @return {function(): CSVCommission[]}
     */
    parseCommissionListToCSVCommissionList(commissionList) {
      return commissionList.map(commission => ({
        Cupom: commission.nameCoupon,
        Perfil: commission.profile,
        Consumidor_Investidor_Comercializador: commission.investorCustomerName,
        Instalacao: commission.installationNumber,
        Contrato: commission.contract,
        Comercializador: commission.nameTrader,
        Comissao: formatCurrencyFraction2(commission.comission),
        Valor_de_Incidencia: formatCurrencyFraction2(commission.value),
        Comissão_Calculada: formatCurrencyFraction2(commission.comissionCalc),
        Status: COMMISSION_STATUS[commission.status] || '',
        Fatura: commission.invoice || '',
        Fatura_XML: commission.invoice || '',
      }));
    },
    /**
     * Método para filtrar a lista de comissões
     * @return {function(): void}
     */
    handleFilterCommissionList() {
      this.commissionList = this.oldCommissionList;
      if (this.search.trader) {
        this.commissionList = filterListByProperty(
          this.commissionList,
          'nameTrader',
          this.search.trader,
        );
      }

      if (this.search.profile) {
        this.commissionList = filterListByProperty(
          this.commissionList,
          'profile',
          this.search.profile,
        );
      }

      if (this.search.status) {
        this.commissionList = filterListByProperty(
          this.commissionList,
          'status',
          this.search.status,
        );
      }

      if (this.search.invoiceNumber) {
        this.commissionList = filterListByProperty(
          this.commissionList,
          'invoice',
          this.search.invoiceNumber,
        );
      }
    },
    /**
     * Método para mudar o status da comissão para pago
     * @return {function(): void}
     */
    async handleChangeCommissionToPaid() {
      this.isLoading = true;
      const { errors, ok } = await API.post('/execute', {
        path: `/change-status-pay-commission/${item.id}`,
        method: 'put',
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
      } else {
        this.$bvToast.toast('Status alterado com sucesso', {
          title: `Sucesso`,
          variant: 'success',
          solid: true,
        });
      }
      await this.getAll();
      this.isLoading = false;
    },
    /**
     * Método para deletar uma comissão
     * @return {function(): void}
     */
    async handleDeleteCommission() {
      this.isLoading = true;
      const { errors, ok } = await API.post('/execute', {
        path: `/commission-item/${this.idDeleteCommission}`,
        method: 'delete',
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
      } else {
        this.$bvToast.toast('Comissão deletada com sucesso!', {
          title: `Sucesso`,
          variant: 'success',
          solid: true,
        });
      }
      await this.getAll();
      this.isLoading = false;
    },
    /**
     * Método para marcar comissões como paga em Lote
     * @return {function(): void}
     */
    async handleMarkCommissionsItemAsPaidInBatch() {
      const listCloseCommissionItem = this.commissionList.filter(
        commissionItem => commissionItem.status === 'INVOICE_CREATED',
      );
      if (!listCloseCommissionItem.length) {
        this.$bvToast.toast('Não há comissões a serem marcadas como pagas', {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        return;
      }
      this.isLoading = true;
      const { errors, ok } = await API.post('/execute', {
        path: `/commission-item/mark-as-paid-in-batch`,
        method: 'post',
        data: listCloseCommissionItem,
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
      } else {
        this.$bvToast.toast(
          'Comissões foram alteradas para Pagas com sucesso!',
          {
            title: `Sucesso`,
            variant: 'success',
            solid: true,
          },
        );
      }
      await this.getAll();
      this.isLoading = false;
    },
    /**
     * Método abrir o Dialog de deleção unitária
     * @param {number} id
     * @return {function(): void}
     */
    showDeleteCommissionDialog(id) {
      this.idDeleteCommission = id;
      this.$refs.deleteModalRef.show();
    },
    /**
     * Método abrir o Dialog de deleção em lote
     * @return {function(): void}
     */
    showDeleteCommissionInBatchDialog() {
      this.$refs.deleteModalInBatchRef.show();
    },
    /**
     * Método realizar a delação de comissões em lote
     * @return {function(): void}
     */
    async handleDeleteCommissionItemInBatch() {
      const commissionWithId = this.commissionList.filter(
        commission => commission.id,
      );
      if (!commissionWithId.length) {
        this.$bvToast.toast('Não há comissões a serem deletadas', {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
        return;
      }
      this.isLoading = true;
      const { errors, ok } = await API.post('/execute', {
        path: `/commission-item/delete-in-batch`,
        method: 'post',
        data: commissionWithId,
      });
      if (!ok) {
        this.$bvToast.toast(errors.message, {
          title: `Erro`,
          variant: 'error',
          solid: true,
        });
      } else {
        this.$bvToast.toast('Comissões deletadas com sucesso!', {
          title: `Sucesso`,
          variant: 'success',
          solid: true,
        });
      }
      await this.getAll();
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-header-comission {
  padding-top: 1rem;
}
.commission-table {
  display: block;
  max-height: 88vh !important;
  height: auto !important;

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    background-color: #e7e7e7;
  }

  td:nth-child(2),
  th:nth-child(2) {
    position: sticky;
    left: 4rem;
    background-color: #e7e7e7;
  }

  tr:nth-child(odd) td:nth-child(-n + 2) {
    background-color: #e7e7e7;
  }

  tr:nth-child(even) td:nth-child(-n + 2) {
    background-color: #f2f2f2;
  }
}

.options-button {
  display: flex;
  gap: 0.5rem;
}
</style>
